import { atomWithReset } from 'jotai/utils'
import { type DialogContext } from '@/features/shared/state/Dialog/types'

export const initialDialogValue: DialogContext = {
  legacySessionData: {},
}

export const dialogAtom = atomWithReset<DialogContext>(initialDialogValue)
dialogAtom.debugLabel = 'dialogAtom'
